<div [class]="['flex m-auto max-w-1170px', classNames()] | joinClassNames">
    <ng-content />
</div>
@if (assetPath()) {
    @for (content of backgroundContent; track content.imgPath) {
        <img
            [ngSrc]="content.imgPath | asset: assetPath() : 'webp'"
            fill
            alt="background"
            [class]="[content.imgStyles, imgCommonStyles] | joinClassNames" />
    }
}
